"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangelogTitle = exports.OperationWrapper = exports.DateWrapper = exports.StyledConnector = exports.CustomDot = exports.StyledTimelineItem = exports.ChangeLogWrapper = exports.User = exports.ChangeLogTime = exports.ChangeLogDate = exports.AffectedEntityName = exports.OperationTitle = exports.StyledTimeline = void 0;
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const TimelineItem_1 = __importDefault(require("@mui/lab/TimelineItem"));
const TimelineDot_1 = __importDefault(require("@mui/lab/TimelineDot"));
const TimelineConnector_1 = __importDefault(require("@mui/lab/TimelineConnector"));
const Timeline_1 = __importDefault(require("@mui/lab/Timeline"));
exports.StyledTimeline = (0, styles_1.styled)(Timeline_1.default)({
    padding: 0,
});
exports.OperationTitle = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.grayScale.gray1,
    fontWeight: "bold",
}));
exports.AffectedEntityName = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.grayScale.gray3,
    fontWeight: "bold",
}));
exports.ChangeLogDate = (0, styles_1.styled)(Typography_1.default)(() => ({
    color: "#FE5000",
    fontWeight: "bold",
}));
exports.ChangeLogTime = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.grayScale.gray3,
    fontWeight: "bold",
}));
exports.User = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.grayScale.gray3,
}));
exports.ChangeLogWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    padding: "22px",
    backgroundColor: theme.palette.grayScale.white,
    justifyContent: "flex-start",
    flexDirection: "column",
    boxShadow: "0px 16px 32px rgba(51, 51, 51, 0.1)",
    maxWidth: "400px",
    maxHeight: "calc(100vh - 180px)",
    overflowY: "scroll",
}));
exports.StyledTimelineItem = (0, styles_1.styled)(TimelineItem_1.default)({
    "&::before": {
        content: "none",
    },
});
exports.CustomDot = (0, styles_1.styled)(TimelineDot_1.default)({
    margin: 0,
    boxShadow: "none",
    padding: "5px",
    borderWidth: "1px",
    borderColor: "#bdbdbd",
    backgroundColor: "#fff",
});
exports.StyledConnector = (0, styles_1.styled)(TimelineConnector_1.default)({
    width: 1,
});
exports.DateWrapper = (0, styles_1.styled)("span")({
    display: "flex",
    "p:nth-of-type(1)": {
        marginRight: "4px",
    },
    "p:nth-of-type(2)": {
        marginLeft: "4px",
    },
});
exports.OperationWrapper = (0, styles_1.styled)("div")({
    marginBottom: "20px",
});
exports.ChangelogTitle = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.institutional.braskemGray,
    fontWeight: "bold",
}));
